import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AuthProvider, useAuth } from './features/auth/AuthContext';
import { LoginPage } from './features/auth/LoginPage';
import { AppRoutes } from './features/layout/routes';
import { captureIncomingPrinterProfile, captureIncomingScan } from './features/scan/incoming';
import { NativeShell } from './platform/NativeShell';

// Before the router reads the address: a code from a printed QR arrives as
// `/?scan=…` and belongs on the scanning screen, not in the address bar.
captureIncomingScan();
captureIncomingPrinterProfile();

function Gate() {
  const { t } = useTranslation();
  const { user, loading } = useAuth();

  if (loading) return <p className="boot">{t('common.loading')}</p>;
  return user ? <AppRoutes /> : <LoginPage />;
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* Inside the router because a scanned label navigates, and outside the
            gate because one scanned while signed out still has to arrive. */}
        <NativeShell />
        <Gate />
      </BrowserRouter>
    </AuthProvider>
  );
}
